/* eslint-disable */
import { IAddNominee, IEditNominee, NomineeData } from '../components/containers/ManageNomineesComponent/types';
import { IChangePlanDeletionsResponse } from '../components/containers/ModularEnrolmentFooter/types';
import {
    getAppPermissionID as getAppPermissionsID,
    getRolePermissions,
    getUserData as getUsersData
} from '../components/pages/LoginContainer/adapters';
import {
    ICoverageAmount,
    IEnrollUserToPolicy,
    IMemberTopUp,
    IPreValidation,
    ITopUpPolicyPlans
} from '../redux/slices/EnrolmentSlice/types';
import {
    IFetchBenefitsByTypeResponse,
    IFetchModularFamilyResponse,
    IFetchModularSummaryResponse,
    ISaveMemberPayload,
    IUserBenefits,
    IPurchaseAttributePayload
} from '../redux/slices/ModularEnrolmentSlice/types';
import { BenefitType, ICompanyData, IDependent, IPolicy } from '../redux/slices/PolicyListSlice/types';
import { getDaysLeft } from '../utils/common';
import { isAllowDBCallsEnabled, isIamAPIEnabled, isPolicyStartDateResolverEnabled } from '../utils/featureFlags';
import { getSecondsFromDate } from '../utils/PolicyServices';

import { FlagsmithFlags, isFlagsmithFeatureEnabled } from '../utils/flagsmith';
import { del, get, patch, post, put, Services } from './provider';
import { NomineeConfig } from './types';
import { sortFamilyMembers } from '../components/containers/ModularAddDependents/utils';
import { ISsoIdResponse } from '../components/pages/LoginContainer/types';
import {
    IGetUserAttributesResponse,
    IUserAttributes
} from '../components/pages/LoginContainer/redux/slices/UserSlice/types';
import { IModularValidationResponse } from '../components/containers/ModularAddDependents/types';
import { IUpgradedFamilyStructureResponse } from '../components/containers/ModularAddOnsModal/types';
import { getPolicyEnrolmentStatus } from '../components/pages/SPAContainer/pages/DashboardPage/utils';

export const LoopEndpoints = {
    DEFAULT_TIMEOUT: 30,
    fetchPolicyWiseFamilyDetails: (userId: string): string => Services.LB(`/userPolicies/allFamilyDetailsWithParental/${userId}`),
    fetchEnrolmentTopUpOptions: (policyId: string): string => Services.LB(`/policyPlan/topUpPolicy/${policyId}`),
    fetchDependents: (userId: string): string => Services.LB(`/user?parentId=${userId}`),
    saveEnrolmentTopUpOptions: (userId: string, topupId: string): string =>
        Services.LB(`/userPolicies/topUpPolicy/${userId}/${topupId}`),
    updateEnrolmentStatus: (userId: string, policyId: string): string =>
        Services.LB(`/userPolicies/enrolmentStatus/${userId}/${policyId}`),
    enrolUserToPolicyFamily: (userId: string, policyId: string): string =>
        Services.LB(`/userPolicies/addUserPolicyForFamily/${userId}/${policyId}`),
    fetchCompanyDetails: (companyId: string): string => Services.LB(`/company/${companyId}`),
    fetchNomineeConfig: (companyId: string, policyId: string): string =>
        Services.LB(`/company/getNomineeConfig/${companyId}/${policyId}`),
    fetchSuperTopupAvailable: (userId: string): string => Services.LB(`/topup/topupAvailabilityAndStatus/${userId}`),
    fetchPolicyPreValidations: (policyId: string): string => Services.LB(`/policyPlan/${policyId}`),
    fetchUserPolicyByPolicyID: (userId: string, policyId: string): string => Services.LB(`/userPolicies/${userId}/${policyId}`),
    fetchSIAndAnnualPremium: (userId: string, policyId: string): string =>
        Services.LB(`/userPolicies/fetchFamilySIAndPremium/${userId}/${policyId}`),
    addExisting: Services.LB(`/registration/enrolment/addExisting`),
    enrolmentAdd: Services.LB(`/registration/enrolment/add`),
    enrolmentEdit: Services.LB(`/registration/enrolment/edit`),
    enrolmentOffboard: Services.LB(`/registration/enrolment/offboard`),
    fetchUserOffboardingDetails: (userId: string): string => Services.LB(`/user/isOffboarded/${userId}`),
    addNominee: Services.LB(`/userPolicies/nominee`),
    deleteNominee: Services.LB(`/userPolicies/nominee`),
    editNominee: Services.LB(`/userPolicies/nominee`),
    fetchNominees: (userId: string, policyId: string) => Services.LB(`/userPolicies/nominee/byUserPolicy/${userId}/${policyId}`),
    checkIfTopUpIsConfigured: (policyId: string) => Services.LB(`/userPolicies/topUpPolicy/isGroupTopUpConfigured/${policyId}`),
    getRolesPermissions: Services.LB(`/roles/getRolePermissions`),
    getAppPermissionID: (value: string) => Services.LB(`/iam/${value}`),
    getUserData: Services.LB(`/user/fetchSelfUsersDetails`),
    fetchPolicyInclusionsExclusions: (policyId: string): string => Services.LB(`/policyPlan/inclusionExclusion/${policyId}`),
    getModularBenefits: (userId: string, policyId: string, type: string, category?: string, benefitId?: string) =>
        Services.EP(`/v1/user/${userId}/policy/${policyId}/benefits?benefitType=${type}${category ? `&subType=${category}` : ''}${
            benefitId ? `&benefitId=${benefitId}` : ''
        }`),
    fetchPolicies: (userId: string, queryString?: string): string =>
        Services.EP(`/v1/user/${userId}/policies${queryString ? `?${queryString}` : ''}`),
    fetchFamily: (userId: string, policyId: string): string => Services.EP(`/v1/family/${userId}/${policyId}`),
    updateBenefits: (userId: string, policyId: string) => Services.EP(`/v1/user/${userId}/policy/${policyId}/benefits`),
    addMember: (userId: string, policyId: string): string => Services.EP(`/v1/family/${userId}/${policyId}/add`),
    editMember: (userId: string, policyId: string, editUserId: string, mode?: string): string =>
        Services.EP(`/v1/family/${userId}/${policyId}/user/${editUserId}?${mode ? `mode=${mode}` : ''}`),
    deleteMember: (userId: string, policyId: string, deleteUserId: string, mode?: string): string =>
        Services.EP(`/v1/family/${userId}/${policyId}/user/${deleteUserId}?${mode ? `mode=${mode}` : ''}`),
    fetchModularSummary: (userId: string, policyId: string): string =>
        Services.EP(`/v1/user/${userId}/policy/${policyId}/benefits/summary`),
    checkoutModular: (userId: string, policyId: string): string =>
        Services.EP(`/v1/user/${userId}/policy/${policyId}/benefits/checkout`),
    validateBenefits: (userId: string, policyId: string) => Services.EP(`/v1/user/${userId}/policy/${policyId}/benefits/validate`),
    generateRedirectCode: Services.LB(`/login/sso/generateId`),
    verifySessionCode: Services.BASE(`/login/verify`),
    fetchRequiredUserAttributes: (userId: string) => Services.EP(`/v1/user/${userId}/attributes`),
    updateUserAttributes: Services.EP(`/v1/user/attributes`),
    getModularUpdatedFamilyStructure: (userId: string, policyId: string) =>
        Services.EP(`/v1/user/${userId}/policy/${policyId}/upgrade`),
    getFamilyStructureDefinition: Services.BENEFITS(`/family-definition/maximum-family-structure`),
    getPlanRecommendation: (userId: string) => `https://vuvrrwmmaaulrjlbvbvz.supabase.co/functions/v1/get-recommendation?user_id=${userId}`
};

export const fetchPolicyWiseFamilyDetails = async (userId: string) => {
    try {
        const isModularFeatureEnabled = isFlagsmithFeatureEnabled(FlagsmithFlags.MODULAR);
        const includeDealPolicies = isFlagsmithFeatureEnabled(FlagsmithFlags.MODULAR_REDIRECT);
        const params = new URLSearchParams();
        if (includeDealPolicies) params.append('includeDealPolicies', 'true');
        params.append('applyEpExclusionList', 'true');
        const result: any = isModularFeatureEnabled
            ? await get(LoopEndpoints.fetchPolicies(userId, params.toString()))
            : await get(LoopEndpoints.fetchPolicyWiseFamilyDetails(userId));

        return (result as any)?.data?.policyWiseFamilyDetails?.map((policyData: any) => {
            if (
                policyData?.policyType === 'GMC' &&
                policyData?.enrolmentStatus === 'PENDING' &&
                policyData?.enrolmentDueDate &&
                getDaysLeft(getSecondsFromDate(policyData?.enrolmentDueDate)) === 'OVERDUE'
            ) {
                policyData.enrolmentStatus = 'ENROLED';
            }
            const dependents: IDependent[] = policyData.family.map((dep: any) => {
                return {
                    doB: getSecondsFromDate(dep.dob),
                    gender: dep.gender,
                    // some entries will have Child 1 and Child 2, thats the way ops use to send the data. Need to cleanse it.
                    relationship:
                        dep?.relationship?.toLowerCase() === 'child 1' || dep?.relationship?.toLowerCase() === 'child 2'
                            ? 'Child'
                            : dep?.relationship?.toLowerCase(),
                    userId: dep.userId,
                    firstName: dep.firstName || '',
                    lastName: dep.lastName || '',
                    // we are not getting the dependents mobile number seperately, so currently going to use userId to get the dependents mobile number
                    mobile: dep.mobile
                } as IDependent;
            });
            const dueDate = policyData?.enrolmentDueDate && getSecondsFromDate(policyData?.enrolmentDueDate);
            return {
                ...policyData,
                enrolmentStatus: policyData.enrolmentStatus,
                enrolmentDueDate: dueDate,
                familyStruture: policyData.familyDefinition,
                policyName: policyData.insurerName,
                dependents: sortFamilyMembers(dependents),
                availableTopUp: policyData.topUpAvailable,
                enrolmentUIStatus: getPolicyEnrolmentStatus(policyData.enrolmentStatus, dueDate)
            } as IPolicy;
        });
    } catch (e) {
        throw e;
    }
};

export const verifySessionCode = async (id: string, context: string | null): Promise<ISsoIdResponse> => {
    const result = await post(LoopEndpoints.verifySessionCode, { id, context }, { unauthorized: true });
    return result.data;
};

export const generateRedirectCode = async (): Promise<{ id: string }> => {
    const result = await post(LoopEndpoints.generateRedirectCode, {});
    return result.data;
};

export const fetchDependents = async (userId: string) => {
    try {
        const result = await get(LoopEndpoints.fetchDependents(userId));

        return (result as any).data.users.map((dep: any) => {
            return {
                doB: dep.dob,
                gender: dep.gender,
                // some entries will have Child 1 and Child 2, thats the way ops use to send the data. Need to cleanse it.
                relationship:
                    dep?.relationship?.toLowerCase() === 'child 1' || dep?.relationship?.toLowerCase() === 'child 2'
                        ? 'Child'
                        : dep?.relationship?.toLowerCase(),
                userId: dep.userId,
                firstName: dep.firstName || '',
                lastName: dep.lastName || '',
                // we are not getting the dependents mobile number seperately, so currently going to use userId to get the dependents mobile number
                mobile: dep.mobile
            } as IDependent;
        });
    } catch (e) {
        throw e;
    }
};

export const fetchCompanyDetails = async (companyId: string) => {
    try {
        const result = await get(LoopEndpoints.fetchCompanyDetails(companyId));
        let companyDetail = {
            companyId: (result as any).data.company.id,
            companyName: (result as any).data.company.name
        };
        return companyDetail as ICompanyData;
    } catch (e) {
        throw e;
    }
};

export const fetchSuperTopupAvailableDetails = async (userId: string) => {
    try {
        const result = await get(LoopEndpoints.fetchSuperTopupAvailable(userId));
        return result;
    } catch (e) {
        throw e;
    }
};

export const fetchPolicyPreValidations = async (policyId: string) => {
    try {
        const result = await get(LoopEndpoints.fetchPolicyPreValidations(policyId));
        return Object.keys((result as any).data.policyPlans.preValidation).map((relation) => {
            const dependentValidations = (result as any).data.policyPlans.preValidation[relation];
            return {
                [relation]: dependentValidations
            } as IPreValidation;
        });
    } catch (e) {
        throw e;
    }
};
export const fetchNomineeConfigAPI = async (companyId: string, policyId: string) => {
    try {
        const result = await get(LoopEndpoints.fetchNomineeConfig(companyId, policyId));
        return (result as any).data.isEnabled as NomineeConfig;
    } catch (e) {
        throw e;
    }
};

export const getRolesPermissions = async (roles: string[]) => {
    try {
        if (!isAllowDBCallsEnabled) {
            const result = await post(LoopEndpoints.getRolesPermissions, { roles });
            return result;
        } else {
            const response = await getRolePermissions(roles);
            return response;
        }
    } catch (e) {
        throw e;
    }
};

export const getAppPermissionID = async (value: string) => {
    try {
        if (isIamAPIEnabled) {
            const result = await get(LoopEndpoints.getAppPermissionID(value));
            return result;
        } else {
            const result = await getAppPermissionsID(value);
            return result;
        }
    } catch (e) {
        throw e;
    }
};

interface IEditMemberDetails {
    userId?: string;
    relationship_to_account_holders: string;
    name: string;
    mobile: string;
    email_address: string;
    date_of_birth: string;
    gender: string;
    policy_start_date: string;
    enrolment_due_date: string;
}

interface IMemberDetails {
    employee_id?: string;
    userId?: string;
    relationship_to_account_holders: string;
    name: string;
    policy_start_date?: string;
    enrolment_due_date: string | null;
    slabId: number;
    data_addition: string;
    mobile: string;
    email_address: string;
    date_of_birth: string;
    gender: string;
}

interface IDeleteMemberDetails {
    companyId: string;
    userId: string;
    relationship: string;
    dateOfLeaving: Date;
    policyId: string;
}

export const offboardMemberAPI = async ({
    companyId,
    policyId,
    userId,
    relationship,
    dateOfLeaving
}: IDeleteMemberDetails) => {
    return await post(LoopEndpoints.enrolmentOffboard, {
        companyId,
        membersList: [
            {
                userId,
                relationship,
                dateOfLeaving: dateOfLeaving.toLocaleDateString('en-GB'),
                policies: [policyId]
            }
        ]
    });
};

export const addNomineeAPI = async (nominee: IAddNominee): Promise<NomineeData> => {
    const response = await post(LoopEndpoints.addNominee, {
        nominee
    });
    return { ...(response as any).data.addedNominee, dob: new Date((response as any).data.addedNominee.dob) };
};
export const editNomineeAPI = async (nominee: IEditNominee) => {
    return await put(`${LoopEndpoints.editNominee}`, { nominee });
};
export const deleteNomineeAPI = async (nomineeId: string) => {
    return await del(`${LoopEndpoints.deleteNominee}?nomineeId=${nomineeId}`);
};
export const fetchNomineesAPI = async (userId: string, policyId: string): Promise<NomineeData[]> => {
    const response = await get(LoopEndpoints.fetchNominees(userId, policyId));
    const nomineesRaw = (response as any).data.nominees;
    return nomineesRaw.map(
        (v: any) =>
            ({
                dob: new Date(v.dob),
                firstName: v.name.split(' ')[0],
                lastName: v.name.split(' ').slice(1).join(' '),
                gender: v.gender,
                percentage: v.percentage,
                relationship: v.relationship,
                id: v.id
            } as NomineeData)
    );
};

export const addExistingAPI = async (companyId: string, policyId: string, memberDetails: IMemberDetails) => {
    return await post(LoopEndpoints.addExisting, {
        companyId,
        policyId,
        membersList: [memberDetails],
        mode: 'EDIT',
        enableEnrolmentPortal: 'true'
    });
};

export const addMemberAPI = async (companyId: string, policyId: string, memberDetails: IMemberDetails) => {
    return await post(LoopEndpoints.enrolmentAdd, {
        companyId,
        policies: [
            {
                id: policyId,
                slab: memberDetails.slabId,
                enrolmentDueDate: memberDetails.enrolment_due_date,
                policyStartDate: isPolicyStartDateResolverEnabled ? undefined : memberDetails.policy_start_date
            }
        ],
        member: memberDetails
    });
};
export const editMembersAPI = async (companyId: string, memberDetails: IEditMemberDetails) => {
    return await post(LoopEndpoints.enrolmentEdit, {
        companyId,
        member: memberDetails
    });
};

export const fetchEnrolmentTopUpOptions = async (policyId: string) => {
    try {
        const result = await get(LoopEndpoints.fetchEnrolmentTopUpOptions(policyId));
        const options: ITopUpPolicyPlans[] = [];
        (result as any)?.data?.topUpPolicyPlans?.map((val: any) => {
            options.push({ policyId: val.id, topUpPolicySlabs: val.topUpPolicySlabs, topUpName: val.topUpPolicyName });
        });
        return options;
    } catch (e) {
        throw e;
    }
};
const getParallelEnrolmentTopUpOptions = async (topUpDetails: IMemberTopUp[] | null, userId: string, result: any) => {
    await Promise.all(
        topUpDetails?.map(async (topup: IMemberTopUp) => {
            const contents = await post(LoopEndpoints.saveEnrolmentTopUpOptions(userId, topup.id), {
                enrolmentCycle: (result as any)?.data?.usersPolicies?.enrolmentCycle,
                enrolmentStatus: 'PENDING',
                policyStatus: 'ENROLED',
                topUpSlabId: topup.topUpSlabId
            });
        }) ?? []
    );
};
export const saveEnrolmentTopUpOptions = async (
    topUpDetails: IMemberTopUp[] | null,
    userId: string,
    policyId: string
) => {
    try {
        const result = await get(LoopEndpoints.fetchUserPolicyByPolicyID(userId, policyId));
        await getParallelEnrolmentTopUpOptions(topUpDetails, userId, result);
    } catch (e) {
        throw e;
    }
};

export const updateUserPolicyEnrolmentStatus = async (
    userId: string,
    policyId: string,
    enrolmentStatus?: 'ENROLED' | 'PENDING'
) => {
    try {
        await put(LoopEndpoints.updateEnrolmentStatus(userId, policyId), {
            enrolmentStatus: enrolmentStatus || 'ENROLED'
        });
        return enrolmentStatus ? enrolmentStatus : 'Enroled';
    } catch (error) {
        throw error;
    }
};
export const fetchSelfUserPolicy = async (id: string, policyId: string) => {
    const response = await get(LoopEndpoints.fetchUserPolicyByPolicyID(id, policyId));
    return (response as any).data.usersPolicies;
};

export const fetchSIAndAnnualPremium = async (userId: string, policyId: string) => {
    try {
        const result: any = await get(LoopEndpoints.fetchSIAndAnnualPremium(userId, policyId));

        return {
            sumInsured: result?.data?.totalSI,
            annualPremium: result?.data?.totalPremium,
            gstOfAnnualPremium: result?.data?.gstOfAnnualPremium,
            annualPremiumWithoutGST: result?.data?.annualPremiumWithoutGST
        } as ICoverageAmount;
    } catch (e) {
        throw e;
    }
};

export const enrolUserToPolicyFamily = async (req: Record<string, unknown>, userId: string, policyId: string) => {
    try {
        const response: any = await post(LoopEndpoints.enrolUserToPolicyFamily(userId, policyId), req);
        return {
            policyId: response?.data?.policy?.id,
            userId: response?.data?.policy?.userId
        } as IEnrollUserToPolicy;
    } catch (error) {
        throw error;
    }
};

export const fetchUserOffboardingDetails = async (userId: string) => {
    try {
        const result = await get(LoopEndpoints.fetchUserOffboardingDetails(userId));
        return (result as any).data.isUserOffboarded;
    } catch (e) {
        throw e;
    }
};

export const checkIfTopUpIsConfigured = async (policyId: string) => {
    try {
        const result = await get(LoopEndpoints.checkIfTopUpIsConfigured(policyId));
        return (result as any).data;
    } catch (e) {
        throw e;
    }
};

export const getUserData = async (key: string, value: string) => {
    try {
        if (!isAllowDBCallsEnabled) {
            const result = await get(LoopEndpoints.getUserData);
            return result;
        } else {
            const result = await getUsersData(key, value);
            return result;
        }
    } catch (e) {
        throw e;
    }
};

export const fetchPolicyInclusions = async (policyId: string) => {
    try {
        const result = await get(LoopEndpoints.fetchPolicyInclusionsExclusions(policyId));
        return (result as any).data;
    } catch (e) {
        throw e;
    }
};

export const fetchBenefitsForUserByTypeAndCategory = async (
    userId: string,
    policyId: string,
    benefitType: BenefitType,
    category?: string,
    benefitId?: string
): Promise<IFetchBenefitsByTypeResponse> => {
    const result = await get(LoopEndpoints.getModularBenefits(userId, policyId, benefitType, category, benefitId));
    return result.data;
};

export const fetchModularSummaryForUser = async (
    userId: string,
    policyId: string
): Promise<IFetchModularSummaryResponse> => {
    const result = await get(LoopEndpoints.fetchModularSummary(userId, policyId));
    return result.data;
};

export const fetchAddedFamily = async (userId: string, policyId: string): Promise<IFetchModularFamilyResponse> => {
    const result = await get(LoopEndpoints.fetchFamily(userId, policyId));
    return result.data;
};

export const updateBenefitIds = async (
    userId: string,
    policyId: string,
    benefitIds: string[],
    userBenefitMapping: IUserBenefits = {},
    deletions: Record<string, string[]> = {},
    email?: string,
    purchaseAttributes: IPurchaseAttributePayload = {}
): Promise<void> => {
    const response = await post(
        LoopEndpoints.updateBenefits(userId, policyId),
        { benefitIds, deletions, email, userBenefitMapping, purchaseAttributes }
    );
    return response.data;
};

export const validateBenefits = async (
    userId: string,
    policyId: string,
    modularPlanId: string
): Promise<IChangePlanDeletionsResponse> => {
    const response = await post(
        LoopEndpoints.validateBenefits(userId, policyId),
        { benefitIds: [modularPlanId] }
    );
    return response.data;
};

export const saveAndCheckoutModular = async (userId: string, policyId: string) => {
    const response = await post(LoopEndpoints.checkoutModular(userId, policyId), {});
    return response.data;
};

export const addMember = async (userId: string, policyId: string, memberDetails: ISaveMemberPayload) => {
    const response = await post(LoopEndpoints.addMember(userId, policyId), { ...memberDetails });
    return response.data;
};

export const editMember = async (
    userId: string,
    policyId: string,
    editUserId: string,
    memberDetails: ISaveMemberPayload,
    mode?: 'validate' | 'commit'
): Promise<IModularValidationResponse> => {
    const response = await put(
        LoopEndpoints.editMember(userId, policyId, editUserId, mode),
        { ...memberDetails }
    );
    return response.data;
};

export const deleteMember = async (
    userId: string,
    policyId: string,
    deleteUserId: string,
    mode?: 'validate' | 'commit'
): Promise<IModularValidationResponse> => {
    const response = await del(
        LoopEndpoints.deleteMember(userId, policyId, deleteUserId, mode),
        {}
    );
    return response.data;
};

export const getRequiredUserAttributes = async (userId: string): Promise<IGetUserAttributesResponse> => {
    const response = await get(LoopEndpoints.fetchRequiredUserAttributes(userId));
    return response.data;
};

export const saveRequiredUserAttributes = async (userId: string, attributes: IUserAttributes) => {
    const response = await patch(LoopEndpoints.updateUserAttributes, { userId, attributes });
    return response.data;
};

export const getModularUpdatedFamilyStructure = async (
    userId: string,
    policyId: string,
    modularBenefitId: string,
    addOnBenefitIds: string[]
): Promise<IUpgradedFamilyStructureResponse> => {
    const response = await post(LoopEndpoints.getModularUpdatedFamilyStructure(userId, policyId), {
        modularBenefitId,
        addOnBenefitIds
    });
    return response.data;
};

interface IPlanRecommendationResponse {
    age: number;
    ctc: number;
    gender: string;
    ailments: string;
    org_name: string;
    company_id: string;
    child_count: number;
    employee_id: string;
    has_parents: boolean;
    company_name: string;
    has_children: boolean;
    parent_count: number;
    marital_status: string;
    opd_deductions: number;
    has_rejected_opd: boolean;
    internal_reasons: string[];
    total_deductions: number;
    claims_amount_kids: number;
    claims_amount_self: number;
    has_parent_over_60: boolean;
    opd_settled_amount: number;
    has_rejected_claims: boolean;
    total_claims_amount: number;
    claims_amount_spouse: number;
    claims_amount_parents: number;
    claims_amount_siblings: number;
    employee_facing_reasons: string[];
    selected_modular_benefits: string;
    recommended_modular_benefit: string;
    recommendations_generated_at: string;
}

export const fetchPlanRecommendation = async (userId: string): Promise<IPlanRecommendationResponse> => {
    const url = LoopEndpoints.getPlanRecommendation(userId);
    const bearerToken = process.env.REACT_APP_PLAN_RECOMMENDATION_API_KEY;
    
    if (!bearerToken) {
        throw new Error('REACT_APP_PLAN_RECOMMENDATION_API_KEY is missing');
    }
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${bearerToken}`
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch plan recommendation: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};
